import { UserContext } from '../../App';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { logout } from '../../utils/Authentication';
import ChangePasswordModal from '../ChangePasswordModal';
import { updatePassword } from '../../api/User';
import Spinner from 'react-bootstrap/esm/Spinner';
import CustomToast from '../CustomToast';

function UserButton({ role, setHeaderType, setIsAuthenticated }) {
  const [changePasswordModalShow, setChangePasswordModalShow] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [showUpdatePwSuccess, setShowUpdatePwSuccess] = useState(false);
  const [showUpdatePwFail, setShowUpdatePwFail] = useState(false);
  const [updatePwMessage, setUpdatePwMessage] = useState('');

  const userContext = useContext(UserContext);
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    userContext.setUser({});
    setIsAuthenticated(false);
    setHeaderType('');

    if (role === 'organizerprofile') {
      navigate('/organizer');
    } else {
      navigate(`/${role}`);
    }
  };

  const onEdit = () => {
    navigate('/organizer/profile');
  };

  const onAdmins = () => {
    navigate('/organizer/administrators');
  };

  const onChangePassword = async (oldPw, newPw) => {
    setUpdating(true);
    const status = await updatePassword(role, oldPw, newPw);
    switch (status.statusCode) {
      case 200:
        setChangePasswordModalShow(false);
        setUpdating(false);
        setUpdatePwMessage(status.message);
        setShowUpdatePwSuccess(true);
        break;
      case 400:
        setChangePasswordModalShow(false);
        setUpdating(false);
        setUpdatePwMessage(status.message);
        setShowUpdatePwFail(true);
        break;
      case 409:
        setChangePasswordModalShow(false);
        setUpdating(false);
        setUpdatePwMessage(status.message);
        setShowUpdatePwFail(true);
        break;
    }
  };

  const updateBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Spara
        </>
      ) : (
        'Spara'
      )}
    </>
  );

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant='white' className='login-button' align='end'>
          <span className='d-none d-md-inline-block'>
            {userContext.user?.email + ' '}
          </span>
          <span className='material-symbols-outlined d-inline-block d-md-none'>
            person
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Header className='d-block d-md-none'>
            {userContext.user?.email}
          </Dropdown.Header>
          {role === 'organizer' && (
            <>
              <Dropdown.Item className='d-flex gap-3' onClick={onAdmins}>
                <span
                  className='material-symbols-outlined'
                  style={{ fontSize: '20px' }}
                >
                  supervisor_account
                </span>
                Användare
              </Dropdown.Item>
              <Dropdown.Item className='d-flex gap-3' onClick={onEdit}>
                <span
                  className='material-symbols-outlined'
                  style={{ fontSize: '20px' }}
                >
                  edit
                </span>
                Redigera konto
              </Dropdown.Item>
            </>
          )}
          <Dropdown.Item
            onClick={() => setChangePasswordModalShow(true)}
            className='d-flex gap-3'
          >
            <span
              className='material-symbols-outlined'
              style={{ fontSize: '20px' }}
            >
              key
            </span>
            Ändra lösenord
          </Dropdown.Item>
          <Dropdown.Item onClick={onLogout} className='d-flex gap-3'>
            <span
              className='material-symbols-outlined'
              style={{ fontSize: '20px' }}
            >
              logout
            </span>
            Logga ut
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <ChangePasswordModal
        show={changePasswordModalShow}
        onHide={() => setChangePasswordModalShow(false)}
        onChangePassword={onChangePassword}
        confirmBtn={updateBtn}
      />
      <CustomToast
        type='success'
        title='Lösenord uppdaterat'
        body={updatePwMessage}
        show={showUpdatePwSuccess}
        onClose={() => setShowUpdatePwSuccess(false)}
      />
      <CustomToast
        type='danger'
        title='Lösenord ej uppdaterat'
        body={updatePwMessage}
        show={showUpdatePwFail}
        onClose={() => setShowUpdatePwFail(false)}
      />
    </>
  );
}

export default UserButton;
